import useCursosList from "./useCursosList";
import useCursosForm from "./useCursosForm";

export default function useCursosLogic() {
  const list = useCursosList();

  const form = useCursosForm({
    centros: list.centros,
    niveles: list.niveles,
    especialidades: list.especialidades,
    onCreated: (nuevo) => list.upsertCurso(nuevo),
    onUpdated: (actualizado) => list.upsertCurso(actualizado),
    onDeleted: (eliminado) => list.removeCurso(eliminado.id),
  });

  return {
    ...list,
    form,
  };
}
